import { enumToOptions } from '@app/shared/helpers';
import { RegionOfOperations } from '@app/shared/models/contracts/enums/shared-enums';

export const REGION_OPTIONS = enumToOptions(RegionOfOperations, undefined, true);
